export const getDaysInMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};

export const getFirstDayOfMonth = (date) => {
  return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
};

export const getDayName = (date, day, dayNames) => {
  const dayOfWeek = new Date(date.getFullYear(), date.getMonth(), day).getDay();
  return dayNames[dayOfWeek]?.substring(0, 3);
};

export const isTodayDate = (year, month, day) => {
  const today = new Date();
  return (
    today.getFullYear() === year &&
    today.getMonth() === month &&
    today.getDate() === day
  );
};

export const isPastDate = (year, month, day) => {
  const today = new Date();
  const dateToCheck = new Date(year, month, day);
  const todayWithoutTime = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );

  return dateToCheck < todayWithoutTime;
};

export const getMonthStartAndEndDates = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();
  const firstDate = new Date(year, month, 1);
  const lastDate = new Date(year, month + 1, 0);

  const formatDate = (date) => date.toLocaleDateString("en-CA");

  return {
    startDate: formatDate(firstDate),
    endDate: formatDate(lastDate),
  };
};
